
import React, { Component } from 'react';
// import CanvasJSReact from '../../assets/libs/canvasjs/canvasjs.react.js';

import Highcharts from 'highcharts'
// var CanvasJSChart = CanvasJSReact.CanvasJSChart;

class PolarRadialBar extends Component {
	constructor() {
		super();
		// this.toggleDataSeries = this.toggleDataSeries.bind(this);
	}
	// toggleDataSeries(e) {
	// 	if (typeof (e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
	// 		e.dataSeries.visible = false;
	// 	}
	// 	else {
	// 		e.dataSeries.visible = true;
	// 	}
	// 	this.chart.render();
	// }
	componentDidMount() {
		Highcharts.chart('container_test1', {
			colors: ['#FFD700', '#C0C0C0', '#CD7F32'],
			chart: {
				type: 'column',
				inverted: true,
				polar: true
			},
			title: {
				text: 'AVG Nationwide'
			},
			tooltip: {
				outside: true
			},
			pane: {
				size: '85%',
				innerSize: '20%',
				endAngle: 270
			},
			xAxis: {
				tickInterval: 1,
				labels: {
					align: 'right',
					useHTML: true,
					allowOverlap: true,
					step: 1,
					y: 3,
					style: {
						fontSize: '13px'
					}
				},
				lineWidth: 0,
				categories: [
					'Quarter 2/FY21 <span class="f16"><span id="flag" class="flag no">' +
					'</span></span>',
					'Quarter 3/FY21 <span class="f16"><span id="flag" class="flag us">' +
					'</span></span>',
					'Quarter 4/FY21 <span class="f16"><span id="flag" class="flag de">' +
					'</span></span>',
					'Quarter 1/FY21 <span class="f16"><span id="flag" class="flag ca">' +
					'</span></span>',
					// 'Austria <span class="f16"><span id="flag" class="flag at">' +
					// '</span></span>'
				]
			},
			yAxis: {
				crosshair: {
					enabled: true,
					color: '#333'
				},
				lineWidth: 0,
				tickInterval: 1,
				reversedStacks: false,
				endOnTick: true,
				showLastLabel: true
			},
			plotOptions: {
				column: {
					stacking: 'normal',
					borderWidth: 0,
					pointPadding: 0,
					groupPadding: 0.15
				}
			},
			series: [{
				name: 'Point',
				data: [8.95, 7.98, 9.21, 9.85]
			},
				//  {
				// 	name: 'Silver medals',
				// 	data: [125, 110, 86, 64, 81]
				// }, {
				// 	name: 'Bronze medals',
				// 	data: [111, 90, 60, 62, 87]
				// }
			]
		});
	}
	render() {


		return (
			<div className={"chart-box"}>
				<center>
					<div id="container_test1" style={{ width: "92%", height: "450px" }}></div>
				</center>
			</div>
		);
	}
}

export default PolarRadialBar;